import { IApplicationState } from '../../types/redux';

export function getIsAuthenticated(state: IApplicationState) {
  const {
    user: { isAuthenticated },
  } = state;

  return isAuthenticated;
}
